module.exports = __webpack_public_path__ + "media/images/icons/flags/earth-bf4e09502d2c138dfcd1afac72c79909.svg";